module.exports = __webpack_public_path__ + "img/gift.1576f348.svg";